export default "__VITE_ASSET__CJfgtM_6__"